import { isIndexable } from "./utils.js";
export function getAndDeleteValueFromObjectRecursive(obj, path) {
    if (!isIndexable(obj) || !path) {
        return undefined;
    }
    const nextKey = path[0];
    if (!nextKey) {
        return undefined;
    }
    if (path.length === 1) {
        if (nextKey in obj) {
            const value = obj?.[nextKey];
            delete obj?.[nextKey];
            return value;
        }
        return undefined;
    }
    return nextKey in obj
        ? getAndDeleteValueFromObjectRecursive(obj[nextKey], getShiftCopy(path))
        : undefined;
}
export function assignValueToObjectRecursive(obj, path, value) {
    if (!isIndexable(obj)) {
        throw new Error("Obj was null or undefined. Can't assign a value to null or undefined.");
    }
    if (path === null || path === undefined) {
        throw new Error("Can't assign to a null or undefined path.");
    }
    const nextPath = path[0];
    if (!nextPath) {
        throw new Error("Path must have a length greater than 0.");
    }
    if (path.length === 1) {
        obj[nextPath] = value;
        return;
    }
    obj[nextPath] ??= {};
    assignValueToObjectRecursive(obj[nextPath], getShiftCopy(path), value);
}
function getShiftCopy(arr) {
    const newPath = [...arr];
    newPath.shift();
    return newPath;
}
export function moveField(was, is, data, conversion) {
    let wasValue = getAndDeleteValueFromObjectRecursive(data, was);
    if (wasValue === undefined) {
        return;
    }
    if (conversion) {
        wasValue = conversion(wasValue);
    }
    assignValueToObjectRecursive(data, is, wasValue);
}
